import React, { useState } from "react"
import styled from "styled-components"
import DetailTable from "./DetailTable"
import RetCalcInput from "./RetCalcInput"
import SummaryTable from "./SummaryTable"

const RetirementCalculator = () => {
  // RetCalcInput state
  const [startingAge, setStartingAge] = useState(25)
  const [startingSalary, setStartingSalary] = useState(50000)
  const [annualRaisePercent, setAnnualRaisePercent] = useState(2.0)
  const [retirementAge, setRetirementAge] = useState(65)
  const [annualSavingsPercent, setAnnualSavingsPercent] = useState(10.0)
  const [interestRate, setInterestRate] = useState(7.0)

  // SummaryTable state
  const [yearsToInvest, setYearsToInvest] = useState()
  const [retirementFund, setRetirementFund] = useState()
  const [lifetimeSalary, setLifetimeSalary] = useState()
  const [totalSaved, setTotalSaved] = useState()
  const [earnedInterest, setEarnedInterest] = useState()

  // DetailTable state
  // const [currentAge, setCurrentAge] = useState()
  // const [currentSalary, setCurrentSalary] = useState()
  // const [currentSavings, setCurrentSavings] = useState()
  // const [currentInterest, setCurrentInterest] = useState()
  const [testArray, setTestArray] = useState([])

  const handleClear = () => {
    setStartingAge("")
    setStartingSalary("")
    setAnnualRaisePercent("")
    setRetirementAge("")
    setAnnualSavingsPercent("")
    setInterestRate("")

    setYearsToInvest("")
    setRetirementFund("")
    setLifetimeSalary("")
    setTotalSaved("")
    setEarnedInterest("")
    setTestArray([])
  }

  const handleDefaults = e => {
    e.preventDefault()
    setStartingAge(25)
    setStartingSalary(50000)
    setAnnualRaisePercent(2.0)
    setRetirementAge(65)
    setAnnualSavingsPercent(10.0)
    setInterestRate(7.0)
  }

  // Async / Await
  // https://www.youtube.com/watch?v=pt_cwna0r0s
  const handleCalculate = () => {
    return new Promise((resolve, reject) => {
      if (
        startingAge === "" ||
        startingSalary === "" ||
        annualRaisePercent === "" ||
        retirementAge === "" ||
        annualSavingsPercent === "" ||
        interestRate === "" ||
        startingAge < 0 ||
        startingSalary < 0 ||
        annualRaisePercent < 0 ||
        retirementAge < 0 ||
        annualSavingsPercent < 0 ||
        interestRate < 0
      )
        return reject(alert("Check the highlighted input boxes for errors."))
      const totalYearsToInvest = retirementAge - startingAge
      resolve(totalYearsToInvest)
      // if (a < 0 || b < 0 || c < 0) return reject("No number can be negative.")
      // resolve(a + b + c)
      // console.log(a + b + c)
      // }, 1000)
    })
  }

  const doCalculations = async e => {
    e.preventDefault()

    const yti = await handleCalculate()
    setYearsToInvest(yti)

    // setTestArray([])

    let currentSavings = 0
    let totalSaved = 0
    let currentInterest = 0
    let newEarnedInterest = 0
    let newLifetimeSalary = 0
    let currentAge = 0
    let currentSalary = 0
    let newAnnualSavingsPercent = annualSavingsPercent
    newAnnualSavingsPercent *= 0.01
    let newInterestRate = interestRate
    newInterestRate *= 0.01
    let newAnnualRaisePercent = annualRaisePercent

    currentAge = startingAge
    currentSalary = startingSalary
    currentSalary *= 1
    newAnnualRaisePercent *= 0.01

    let newRetirementFund = 0

    let array = []

    for (let i = 0; i < yti + 1; i++) {
      currentSavings = currentSalary * newAnnualSavingsPercent
      totalSaved += currentSavings

      currentInterest = (totalSaved + newEarnedInterest) * newInterestRate
      newEarnedInterest += currentInterest

      newRetirementFund = totalSaved + newEarnedInterest

      // console.log(
      //   `${currentAge}   ${currentSalary}   ${currentSavings}   ${currentInterest}   ${newRetirementFund}`
      // )
      array.push({
        currentAge,
        currentSalary,
        currentSavings,
        currentInterest,
        newRetirementFund,
      })

      newLifetimeSalary += currentSalary
      currentSalary += currentSalary * newAnnualRaisePercent
      currentAge++
    }
    setLifetimeSalary(formatNumberWithCommas(newLifetimeSalary))
    setTotalSaved(formatNumberWithCommas(totalSaved))
    setEarnedInterest(formatNumberWithCommas(newEarnedInterest))
    setRetirementFund(formatNumberWithCommas(totalSaved + newEarnedInterest))
    setTotalSaved(formatNumberWithCommas(totalSaved))
    return array
  }

  function formatNumberWithCommas(num) {
    let resultString = ""
    let numString = num.toFixed(0)
    let commaArray = []
    let revArray = numString.split("").reverse()
    let i = 1

    while (revArray.length > 0) {
      commaArray = commaArray.concat(revArray.shift())
      if (i % 3 === 0 && revArray.length !== 0) {
        commaArray = commaArray.concat([","])
      }
      i = i + 1
    }
    resultString = commaArray.reverse().join("")
    return resultString
  }

  return (
    <Wrapper>
      <HeadingContainer>
        <h1>
          To get started, replace the default values with values that reflect
          your current or ideal situation.
        </h1>
        <h2>
          This is an extremely basic example of a retirement calculator and
          should not be used as an actual guide for retirement.
        </h2>
      </HeadingContainer>
      <Container>
        <Container2>
          <RetCalcInput
            setTestArray={setTestArray}
            handleClear={handleClear}
            handleDefaults={handleDefaults}
            doCalculations={doCalculations}
            startingAge={startingAge}
            setStartingAge={setStartingAge}
            startingSalary={startingSalary}
            setStartingSalary={setStartingSalary}
            annualRaisePercent={annualRaisePercent}
            setAnnualRaisePercent={setAnnualRaisePercent}
            retirementAge={retirementAge}
            setRetirementAge={setRetirementAge}
            annualSavingsPercent={annualSavingsPercent}
            setAnnualSavingsPercent={setAnnualSavingsPercent}
            interestRate={interestRate}
            setInterestRate={setInterestRate}
          />
          <SummaryTable
            yearsToInvest={yearsToInvest}
            retirementFund={retirementFund}
            lifetimeSalary={lifetimeSalary}
            totalSaved={totalSaved}
            earnedInterest={earnedInterest}
          />
        </Container2>
        <DetailTable
          formatNumberWithCommas={formatNumberWithCommas}
          testArray={testArray}
        />
      </Container>
    </Wrapper>
  )
}

export default RetirementCalculator

const Wrapper = styled.div`
  /* background: lightskyblue; */
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HeadingContainer = styled.div`
  /* background: lightgoldenrodyellow; */
  width: 90%;
  max-width: 1200px;
  /* font-size: clamp(); */
  text-align: center;

  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1rem;
  }
`

const Container = styled.div`
  /* background: lavenderblush; */

  @media screen and (min-width: 1000px) {
    display: flex;
    margin-top: 20px;
  }
`

const Container2 = styled.div``
